import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const TwitterIcon = ({ className = '', color = 'currentColor' }) => {
    return (
        <svg
            className={`logo-24-24 ${className ? className : ''}`}
            fill='none'
            height='20'
            viewBox='0 0 26 20'
            width='26'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M25.5556 2.35844C24.6001 2.77038 23.6375 3.07577 22.575 3.1752C23.6375 2.56441 24.4931 1.53458 24.9138 0.41242C23.8514 1.02322 22.7889 1.43515 21.6195 1.64111C20.55 0.618386 19.1667 0.000488281 17.6764 0.000488281C14.8028 0.000488281 12.4569 2.25901 12.4569 5.0289C12.4569 5.43373 12.4569 5.84566 12.5639 6.15816C7.07341 6.15816 3.30853 3.07577 0.755829 0.000488281C0.221044 0.717817 0.00713009 1.64111 0.00713009 2.56441C0.00713009 4.30447 0.969742 5.84566 2.35305 6.76895C1.4974 6.66952 0.648872 6.46356 0.00713009 6.15816C0.00713009 6.15816 0.00713009 6.15816 0.00713009 6.25759C0.00713009 8.72208 1.81827 10.7675 4.16419 11.1795C3.73636 11.2789 3.30853 11.3854 2.77375 11.3854C2.46001 11.3854 2.13914 11.3854 1.81827 11.286C2.46001 13.3386 5.43341 15.6965 7.7722 15.6965C5.96106 17.0246 4.27827 18.1823 0.912698 18.1823C0.48487 18.1823 0.827133 18.1823 0 18.1823C2.33879 19.617 5.11254 20.0005 7.98611 20.0005C17.6764 20.0005 22.8959 12.3087 22.8959 5.63969C22.8959 5.43373 22.8959 5.23486 22.8959 5.0289C23.9583 4.30447 24.814 3.38827 25.5556 2.35844Z'
                fill={color}/>
        </svg>


    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default TwitterIcon;
